import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import notEmpty from '../../core/util/notEmpty';

const useProductLink: (productId?: string, parentId?: string) => string = (
    ...path
) => {
    const { storeRootPath } = useStoreAndLanguageParams();
    const filteredPath = path.filter(notEmpty);
    const [productId, parentId] = filteredPath;

    if (parentId) {
        return `${storeRootPath}/product/${parentId}/${productId}`;
    }

    return `${storeRootPath}/product/${productId}`;
};

export default useProductLink;
